<template>
<section class="home-container">
    <MasterPage title="首页">
        <div slot="title-icon">
            <Icon type="ios-home" />
        </div>
        <div slot="paddingContent" style="text-align: center">
            <img :src="require('@/assets/home.jpg')" width="500px" >
            <p style="font-size: 40px;font-weight: bold;letter-spacing: 10px"> 欢迎使用食疗后台管理系统</p>
        </div>
    </MasterPage>
</section>
</template>

<script>
import MasterPage from '@/components/Master'
export default {
    components:{
        MasterPage
    },
    data(){
      return{
        formItem: {
            input: '',
            select: '',
            radio: 'male',
            checkbox: [],
            switch: true,
            date: '',
            time: '',
            slider: [20, 50],
            textarea: ''
        },
        columns1: [],
        data1: [],
      }
    },
    methods:{
    }
}
</script>

<style lang="postcss" scoped>
    .home-container{

    }
</style>
